module.exports = require("/opt/build/repo/src/theme/emotionCacheProps")